import React from 'react';
import { Animated } from 'react-native';

import styles from './styles';

interface StarsProps {
  starAnimations: Animated.Value[];
}

const starPositions = [
  { top: '10%', left: '15%', size: 4 },
  { top: '15%', right: '20%', size: 6 },
  { top: '25%', left: '10%', size: 3 },
  { top: '30%', right: '15%', size: 5 },
  { top: '45%', left: '8%', size: 4 },
  { top: '55%', right: '12%', size: 3 },
  { top: '65%', left: '12%', size: 5 },
  { top: '75%', right: '18%', size: 4 },
  { top: '20%', left: '70%', size: 3 },
  { top: '40%', right: '75%', size: 4 },
  { top: '60%', left: '75%', size: 3 },
  { top: '80%', right: '70%', size: 5 },
  { top: '12%', left: '50%', size: 2 },
  { top: '35%', left: '45%', size: 3 },
  { top: '70%', left: '50%', size: 4 },
  { top: '85%', left: '40%', size: 3 },
  { top: '18%', left: '85%', size: 4 },
  { top: '50%', right: '5%', size: 3 },
  { top: '90%', left: '20%', size: 2 },
  { top: '5%', left: '40%', size: 3 },
];

const Stars: React.FC<StarsProps> = ({ starAnimations }) => (
  <>
    {starPositions.map((star, index) => {
      if (index < starAnimations.length) {
        const style: any = {
          position: 'absolute',
          width: star.size,
          height: star.size,
          opacity: starAnimations[index],
          transform: [
            {
              scale: starAnimations[index].interpolate({
                inputRange: [0, 1],
                outputRange: [0, 1],
              }),
            },
          ],
        };
        if (star.left) style.left = star.left;
        if (star.right) style.right = star.right;
        if (star.top) style.top = star.top;
        return <Animated.View key={index} style={[styles.star, style]} />;
      }
      return null;
    })}
  </>
);

export default Stars;
